import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-newsslider',
  templateUrl: './newsslider.component.html',
  styleUrls: ['./newsslider.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NewssliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
